import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import Typography from "../Typography";
import Icon from "../Icon";
import Button from "../Button";

const styles = theme => ({
  smallPaper: {
    margin: "16px 16px 280px 16px",
    [theme.breakpoints.up("md")]: {
      margin: "16px 16px 280px 16px"
    },
    maxWidth: "450px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "350px"
    }
  },
  largePaper: {
    margin: "16px 16px 280px 16px",
    [theme.breakpoints.up("md")]: {
      margin: "16px 16px 280px 16px"
    },
    maxWidth: "550px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "450px"
    }
  },
  content: {
    textAlign: "center"
  },
  message: {
    marginTop: "20px"
  },
  actionsLeft: {
    display: "flex",
    marginTop: "20px",
    padding: "8px 0px"
  },
  actionsCenter: {
    display: "flex",
    justifyContent: "center",
    marginTop: "20px",
    padding: "8px 0px"
  },
  cancel: {
    padding: "8px",
    cursor: "pointer",
    "&:hover": {
      background: "#f5f5f5"
    }
  }
});

const DialogTitle = withStyles(theme => ({
  smallRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
    width: "450px",
    [theme.breakpoints.down("md")]: {
      width: "350px"
    },
    background: "#F9F9F9",
    justifyContent: "center",
    textAlign: "center"
  },
  largeRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2,
    width: "550px",
    [theme.breakpoints.down("md")]: {
      width: "450px"
    },
    background: "#F9F9F9",
    justifyContent: "center"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose, large } = props;
  return (
    <MuiDialogTitle
      disableTypography
      className={large ? `${classes.largeRoot}` : `${classes.smallRoot}`}
    >
      <Typography type="h4" color="black" font_weight="500">
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <Icon type="icon-e-remove" size="md" />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    background: "#FFF"
  }
}))(MuiDialogContent);

class PopupModal extends React.Component {
  render() {
    const {
      classes,
      loading,
      open,
      header,
      title,
      other,
      actionButton,
      handleCancel,
      handleAction,
      actions,
      large,
      left
    } = this.props;

    return (
      <div>
        <Dialog
          onClose={handleCancel}
          aria-labelledby="customized-dialog-title"
          open={open}
          maxWidth="md"
          classes={{
            paper: large ? classes.largePaper : classes.smallPaper
          }}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={handleCancel}
            large={large}
            left={left}
          >
            {header}
          </DialogTitle>
          <DialogContent dividers>
            <div className={!left && `${classes.content}`}>
              <div className={classes.message}>
                <Typography type="body1" color="black">
                  {title}
                </Typography>
                {other && (
                  <>
                    <br />
                    {other}
                  </>
                )}
              </div>

              <div
                className={
                  left ? `${classes.actionsLeft}` : `${classes.actionsCenter}`
                }
              >
                {actions && (
                  <div>
                    <Button
                      variant="primary"
                      size="md"
                      onClick={handleAction}
                      state={loading ? "inactive" : "active"}
                      color="hylyBlue"
                    >
                      {actionButton}
                    </Button>

                    <Button
                      variant="tertiary"
                      size="md"
                      onClick={handleCancel}
                      state={loading ? "inactive" : "active"}
                      color="darkBlack"
                    >
                      cancel
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(PopupModal);
